import format from "date-fns/format";
import ruLocale from "date-fns/locale/ru";

export const showDate = (currentDate) => {
  return format(new Date(currentDate), "MMMM yyyy", {
    locale: ruLocale,
  });
};

export const newFormat = (selectedDate) => {
  return format(new Date(selectedDate), "yyyy-MM") + "-01";
};
